export const country = {
    "status": "OK",
    "status-code": 200,
    "version": "1.0",
    "access": "public",
    "data": [
        {
            "country": "Serbia", "dial_code": "+381", "flag": "flags/Serbia_and_Montenegro.png", "code": "RS"
        },
        {
            "country": "United States", "dial_code": "+1", "flag": "flags/United_States_of_America.png", "code": "US"
        },
        {
            "country": "Afghanistan", "dial_code": "+93", "flag": "flags/Afghanistan.png", "code": "AF"
        },
        {
            "country": "Aland Islands", "dial_code": "+358", "flag": "flags/Aland.png", "code": "AX"
        },
        {
            "country": "Albania", "dial_code": "+355", "flag": "flags/Albania.png", "code": "AL"
        },
        {
            "country": "Algeria", "dial_code": "+213", "flag": "flags/Algeria.png", "code": "DZ"
        },
        {
            "country": "AmericanSamoa", "dial_code": "+1684", "flag": "flags/American_Samoa.png", "code": "AS"
        },
        {
            "country": "Andorra", "dial_code": "+376", "flag": "flags/Andorra.png", "code": "AD"
        },
        {
            "country": "Angola", "dial_code": "+244", "flag": "flags/Angola.png", "code": "AO"
        },
        {
            "country": "Anguilla", "dial_code": "+1264", "flag": "flags/Anguilla.png", "code": "AI"
        },
        {
            "country": "Antigua and Barbuda", "dial_code": "+1268", "flag": "flags/Antigua_and_Barbuda.png", "code": "AG"
        },
        {
            "country": "Argentina", "dial_code": "+54", "flag": "flags/Argentina.png", "code": "AR"
        },
        {
            "country": "Armenia", "dial_code": "+374", "flag": "flags/Armenia.png", "code": "AM"
        },
        {
            "country": "Aruba", "dial_code": "+297", "flag": "flags/Aruba.png", "code": "AW"
        },
        {
            "country": "Australia", "dial_code": "+61", "flag": "flags/Australia.png", "code": "AU"
        },
        {
            "country": "Austria", "dial_code": "+43", "flag": "flags/Austria.png", "code": "AT"
        },
        {
            "country": "Azerbaijan", "dial_code": "+994", "flag": "flags/Azerbaijan.png", "code": "AZ"
        },
        {
            "country": "Bahamas", "dial_code": "+1242", "flag": "flags/Bahamas.png", "code": "BS"
        },
        {
            "country": "Bahrain", "dial_code": "+973", "flag": "flags/Bahrain.png", "code": "BH"
        },
        {
            "country": "Bangladesh", "dial_code": "+880", "flag": "flags/Bangladesh.png", "code": "BD"
        },
        {
            "country": "Barbados", "dial_code": "+1246", "flag": "flags/Barbados.png", "code": "BB"
        },
        {
            "country": "Belarus", "dial_code": "+375", "flag": "flags/Belarus.png", "code": "BY"
        },
        {
            "country": "Belgium", "dial_code": "+32", "flag": "flags/Belgium.png", "code": "BE"
        },
        {
            "country": "Belize", "dial_code": "+501", "flag": "flags/Belize.png", "code": "BZ"
        },
        {
            "country": "Benin", "dial_code": "+229", "flag": "flags/Benin.png", "code": "BJ"
        },
        {
            "country": "Bermuda", "dial_code": "+1441", "flag": "flags/Bermuda.png", "code": "BM"
        },
        {
            "country": "Bhutan", "dial_code": "+975", "flag": "flags/Bhutan.png", "code": "BT"
        },
        {
            "country": "Bolivia, Plurinational State of", "dial_code": "+591", "flag": "flags/Bolivia.png", "code": "BO"
        },
        {
            "country": "Bosnia and Herzegovina", "dial_code": "+387", "flag": "flags/Bosnia.png", "code": "BA"
        },
        {
            "country": "Botswana", "dial_code": "+267", "flag": "flags/Botswana.png", "code": "BW"
        },
        {
            "country": "Brazil", "dial_code": "+55", "flag": "flags/Brazil.png", "code": "BR"
        },
        {
            "country": "British Indian Ocean Territory", "dial_code": "+246", "flag": "flags/British_Virgin_Islands.png", "code": "IO"
        },
        {
            "country": "Brunei Darussalam", "dial_code": "+673", "flag": "flags/Brunei.png", "code": "BN"
        },
        {
            "country": "Bulgaria", "dial_code": "+359", "flag": "flags/Bulgaria.png", "code": "BG"
        },
        {
            "country": "Burkina Faso", "dial_code": "+226", "flag": "flags/Burkina_Faso.png", "code": "BF"
        },
        {
            "country": "Burundi", "dial_code": "+257", "flag": "flags/Burundi.png", "code": "BI"
        },
        {
            "country": "Cambodia", "dial_code": "+855", "flag": "flags/Cambodia.png", "code": "KH"
        },
        {
            "country": "Cameroon", "dial_code": "+237", "flag": "flags/Cameroon.png", "code": "CM"
        },
        {
            "country": "Canada", "dial_code": "+1", "flag": "flags/Canada.png", "code": "CA"
        },
        {
            "country": "Cape Verde", "dial_code": "+238", "flag": "flags/Cape_Verde.png", "code": "CV"
        },
        {
            "country": "Cayman Islands", "dial_code": "+ 345", "flag": "flags/Cayman_Islands.png", "code": "KY"
        },
        {
            "country": "Central African Republic", "dial_code": "+236", "flag": "flags/Central_African_Republic.png", "code": "CF"
        },
        {
            "country": "Chad", "dial_code": "+235", "flag": "flags/Chad.png", "code": "TD"
        },
        {
            "country": "Chile", "dial_code": "+56", "flag": "flags/Chile.png", "code": "CL"
        },
        {
            "country": "China", "dial_code": "+86", "flag": "flags/China.png", "code": "CN"
        },
        {
            "country": "Christmas Island", "dial_code": "+61", "flag": "flags/Christmas_Island.png", "code": "CX"
        },
        {
            "country": "Cocos (Keeling) Islands", "dial_code": "+61", "flag": "flags/Cocos.png", "code": "CC"
        },
        {
            "country": "Colombia", "dial_code": "+57", "flag": "flags/Colombia.png", "code": "CO"
        },
        {
            "country": "Comoros", "dial_code": "+269", "flag": "flags/Comoros.png", "code": "KM"
        },
        {
            "country": "Congo", "dial_code": "+242", "flag": "flags/Congo.jpg", "code": "CG"
        },
        {
            "country": "Cook Islands", "dial_code": "+682", "flag": "flags/Cook_Islands.png", "code": "CK"
        },
        {
            "country": "Costa Rica", "dial_code": "+506", "flag": "flags/Costa_Rica.png", "code": "CR"
        },
        {
            "country": "Cote d'Ivoire", "dial_code": "+225", "flag": "flags/Côte_d'Ivoire.png", "code": "CI"
        },
        {
            "country": "Croatia", "dial_code": "+385", "flag": "flags/Croatia.png", "code": "HR"
        },
        {
            "country": "Cuba", "dial_code": "+53", "flag": "flags/Cuba.png", "code": "CU"
        },
        {
            "country": "Cyprus", "dial_code": "+357", "flag": "flags/Cyprus.png", "code": "CY"
        },
        {
            "country": "Czech Republic", "dial_code": "+420", "flag": "flags/Czech_Republic.png", "code": "CZ"
        },
        {
            "country": "Denmark", "dial_code": "+45", "flag": "flags/Denmark.png", "code": "DK"
        },
        {
            "country": "Djibouti", "dial_code": "+253", "flag": "flags/Djibouti.png", "code": "DJ"
        },
        {
            "country": "Dominica", "dial_code": "+1767", "flag": "flags/Dominica.png", "code": "DM"
        },
        {
            "country": "Dominican Republic", "dial_code": "+1849", "flag": "flags/Dominican_Republic.png", "code": "DO"
        },
        {
            "country": "Ecuador", "dial_code": "+593", "flag": "flags/Ecuador.png", "code": "EC"
        },
        {
            "country": "Egypt", "dial_code": "+20", "flag": "flags/Egypt.png", "code": "EG"
        },
        {
            "country": "El Salvador", "dial_code": "+503", "flag": "flags/El_Salvador.png", "code": "SV"
        },
        {
            "country": "Equatorial Guinea", "dial_code": "+240", "flag": "flags/Equatorial_Guinea.png", "code": "GQ"
        },
        {
            "country": "Eritrea", "dial_code": "+291", "flag": "flags/Eritrea.png", "code": "ER"
        },
        {
            "country": "Estonia", "dial_code": "+372", "flag": "flags/Estonia.png", "code": "EE"
        },
        {
            "country": "Ethiopia", "dial_code": "+251", "flag": "flags/Ethiopia.png", "code": "ET"
        },
        {
            "country": "Falkland Islands (Malvinas)", "dial_code": "+500", "flag": "flags/Falkland_Islands.png", "code": "FK"
        },
        {
            "country": "Faroe Islands", "dial_code": "+298", "flag": "flags/Faroe_Islands.png", "code": "FO"
        },
        {
            "country": "Fiji", "dial_code": "+679", "flag": "flags/Fiji.png", "code": "FJ"
        },
        {
            "country": "Finland", "dial_code": "+358", "flag": "flags/Finland.png", "code": "FI"
        },
        {
            "country": "France", "dial_code": "+33", "flag": "flags/France.png", "code": "FR"
        },
        {
            "country": "French Guiana", "dial_code": "+594", "flag": "flags/French.png", "code": "GF"
        },
        {
            "country": "French Polynesia", "dial_code": "+689", "flag": "flags/French_Polynesia.png", "code": "PF"
        },
        {
            "country": "Gabon", "dial_code": "+241", "flag": "flags/Gabon.png", "code": "GA"
        },
        {
            "country": "Gambia", "dial_code": "+220", "flag": "flags/Gambia.png", "code": "GM"
        },
        {
            "country": "Georgia", "dial_code": "+995", "flag": "flags/Georgia.png", "code": "GE"
        },
        {
            "country": "Germany", "dial_code": "+49", "flag": "flags/Germany.png", "code": "DE"
        },
        {
            "country": "Ghana", "dial_code": "+233", "flag": "flags/Ghana.png", "code": "GH"
        },
        {
            "country": "Gibraltar", "dial_code": "+350", "flag": "flags/Gibraltar.png", "code": "GI"
        },
        {
            "country": "Greece", "dial_code": "+30", "flag": "flags/Greece.png", "code": "GR"
        },
        {
            "country": "Greenland", "dial_code": "+299", "flag": "flags/Greenland.png", "code": "GL"
        },
        {
            "country": "Grenada", "dial_code": "+1473", "flag": "flags/Grenada.png", "code": "GD"
        },
        {
            "country": "Guadeloupe", "dial_code": "+590", "flag": "flags/Guadeloupe.jpg", "code": "GP"
        },
        {
            "country": "Guam", "dial_code": "+1671", "flag": "flags/Guam.png", "code": "GU"
        },
        {
            "country": "Guatemala", "dial_code": "+502", "flag": "flags/Guatemala.png", "code": "GT"
        },
        {
            "country": "Guernsey", "dial_code": "+44", "flag": "flags/Guernsey.png", "code": "GG"
        },
        {
            "country": "Guinea", "dial_code": "+224", "flag": "flags/Guinea.png", "code": "GN"
        },
        {
            "country": "Guinea-Bissau", "dial_code": "+245", "flag": "flags/Guinea_Bissau.png", "code": "GW"
        },
        {
            "country": "Guyana", "dial_code": "+595", "flag": "flags/Guyana.png", "code": "GY"
        },
        {
            "country": "Haiti", "dial_code": "+509", "flag": "flags/Haiti.png", "code": "HT"
        },
        {
            "country": "Holy See (Vatican City State)", "dial_code": "+379", "flag": "flags/Holy.png", "code": "VA"
        },
        {
            "country": "Honduras", "dial_code": "+504", "flag": "flags/Honduras.png", "code": "HN"
        },
        {
            "country": "Hong Kong", "dial_code": "+852", "flag": "flags/Hong_Kong.png", "code": "HK"
        },
        {
            "country": "Hungary", "dial_code": "+36", "flag": "flags/Hungary.png", "code": "HU"
        },
        {
            "country": "Iceland", "dial_code": "+354", "flag": "flags/Iceland.png", "code": "IS"
        },
        {
            "country": "India", "dial_code": "+91", "flag": "flags/India.png", "code": "IN"
        },
        {
            "country": "Indonesia", "dial_code": "+62", "flag": "flags/Indonesia.png", "code": "ID"
        },
        {
            "country": "Iran, Islamic Republic of Persian Gulf", "dial_code": "+98", "flag": "flags/Iran.png", "code": "IR"
        },
        {
            "country": "Iraq", "dial_code": "+964", "flag": "flags/Iraq.png", "code": "IQ"
        },
        {
            "country": "Ireland", "dial_code": "+353", "flag": "flags/Ireland.png", "code": "IE"
        },
        {
            "country": "Isle of Man", "dial_code": "+44", "flag": "flags/Isle.png", "code": "IM"
        },
        {
            "country": "Israel", "dial_code": "+972", "flag": "flags/Israel.png", "code": "IL"
        },
        {
            "country": "Italy", "dial_code": "+39", "flag": "flags/Italy.png", "code": "IT"
        },
        {
            "country": "Jamaica", "dial_code": "+1876", "flag": "flags/Jamaica.png", "code": "JM"
        },
        {
            "country": "Japan", "dial_code": "+81", "flag": "flags/Japan.png", "code": "JP"
        },
        {
            "country": "Jersey", "dial_code": "+44", "flag": "flags/Jersey.png", "code": "JE"
        },
        {
            "country": "Jordan", "dial_code": "+962", "flag": "flags/Jordan.png", "code": "JO"
        },
        {
            "country": "Kazakhstan", "dial_code": "+77", "flag": "flags/Kazakhstan.png", "code": "KZ"
        },
        {
            "country": "Kenya", "dial_code": "+254", "flag": "flags/Kenya.png", "code": "KE"
        },
        {
            "country": "Kiribati", "dial_code": "+686", "flag": "flags/Kiribati.png", "code": "KI"
        },
        {
            "country": "Kuwait", "dial_code": "+965", "flag": "flags/Kuwait.png", "code": "KW"
        },
        {
            "country": "Kyrgyzstan", "dial_code": "+996", "flag": "flags/Kyrgyzstan.png", "code": "KG"
        },
        {
            "country": "Laos", "dial_code": "+856", "flag": "flags/Laos.png", "code": "LA"
        },
        {
            "country": "Latvia", "dial_code": "+371", "flag": "flags/Latvia.png", "code": "LV"
        },
        {
            "country": "Lebanon", "dial_code": "+961", "flag": "flags/Lebanon.png", "code": "LB"
        },
        {
            "country": "Lesotho", "dial_code": "+266", "flag": "flags/Lesotho.png", "code": "LS"
        },
        {
            "country": "Liberia", "dial_code": "+231", "flag": "flags/Liberia.png", "code": "LR"
        },
        {
            "country": "Libyan Arab Jamahiriya", "dial_code": "+218", "flag": "flags/Libya.png", "code": "LY"
        },
        {
            "country": "Liechtenstein", "dial_code": "+423", "flag": "flags/Liechtenstein.png", "code": "LI"
        },
        {
            "country": "Lithuania", "dial_code": "+370", "flag": "flags/Lithuania.png", "code": "LT"
        },
        {
            "country": "Luxembourg", "dial_code": "+352", "flag": "flags/Luxembourg.png", "code": "LU"
        },
        {
            "country": "Macao", "dial_code": "+853", "flag": "flags/Macao.png", "code": "MO"
        },
        {
            "country": "Macedonia", "dial_code": "+389", "flag": "flags/Macedonia.png", "code": "MK"
        },
        {
            "country": "Madagascar", "dial_code": "+261", "flag": "flags/Madagascar.png", "code": "MG"
        },
        {
            "country": "Malawi", "dial_code": "+265", "flag": "flags/Malawi.png", "code": "MW"
        },
        {
            "country": "Malaysia", "dial_code": "+60", "flag": "flags/Malaysia.png", "code": "MY"
        },
        {
            "country": "Maldives", "dial_code": "+960", "flag": "flags/Maldives.png", "code": "MV"
        },
        {
            "country": "Mali", "dial_code": "+223", "flag": "flags/Mali.png", "code": "ML"
        },
        {
            "country": "Malta", "dial_code": "+356", "flag": "flags/Malta.png", "code": "MT"
        },
        {
            "country": "Marshall Islands", "dial_code": "+692", "flag": "flags/Marshall_Islands.png", "code": "MH"
        },
        {
            "country": "Martinique", "dial_code": "+596", "flag": "flags/Martinique.png", "code": "MQ"
        },
        {
            "country": "Mauritania", "dial_code": "+222", "flag": "flags/Mauritania.png", "code": "MR"
        },
        {
            "country": "Mauritius", "dial_code": "+230", "flag": "flags/Mauritius.png", "code": "MU"
        },
        {
            "country": "Mayotte", "dial_code": "+262", "flag": "flags/Mayotte.png", "code": "YT"
        },
        {
            "country": "Mexico", "dial_code": "+52", "flag": "flags/Mexico.png", "code": "MX"
        },
        {
            "country": "Micronesia", "dial_code": "+691", "flag": "flags/Micronesia.png", "code": "FM"
        },
        {
            "country": "Moldova", "dial_code": "+373", "flag": "flags/Moldova.png", "code": "MD"
        },
        {
            "country": "Monaco", "dial_code": "+377", "flag": "flags/Monaco.png", "code": "MC"
        },
        {
            "country": "Mongolia", "dial_code": "+976", "flag": "flags/Mongolia.png", "code": "MN"
        },
        {
            "country": "Montenegro", "dial_code": "+382", "flag": "flags/Montenegro.png", "code": "ME"
        },
        {
            "country": "Montserrat", "dial_code": "+1664", "flag": "flags/Montserrat.png", "code": "MS"
        },
        {
            "country": "Morocco", "dial_code": "+212", "flag": "flags/Morocco.png", "code": "MA"
        },
        {
            "country": "Mozambique", "dial_code": "+258", "flag": "flags/Mozambique.png", "code": "MZ"
        },
        {
            "country": "Myanmar", "dial_code": "+95", "flag": "flags/Myanmar.png", "code": "MM"
        },
        {
            "country": "Namibia", "dial_code": "+264", "flag": "flags/Namibia.png", "code": "NA"
        },
        {
            "country": "Nauru", "dial_code": "+674", "flag": "flags/Nauru.png", "code": "NR"
        },
        {
            "country": "Nepal", "dial_code": "+977", "flag": "flags/Nepal.png", "code": "NP"
        },
        {
            "country": "Netherlands", "dial_code": "+31", "flag": "flags/Netherlands.png", "code": "NL"
        },
        {
            "country": "Netherlands Antilles", "dial_code": "+599", "flag": "flags/Netherlands_Antilles.png", "code": "AN"
        },
        {
            "country": "New Caledonia", "dial_code": "+687", "flag": "flags/New_Caledonia.png", "code": "NC"
        },
        {
            "country": "New Zealand", "dial_code": "+64", "flag": "flags/New_Zealand.png", "code": "NZ"
        },
        {
            "country": "Nicaragua", "dial_code": "+505", "flag": "flags/Nicaragua.png", "code": "NI"
        },
        {
            "country": "Niger", "dial_code": "+227", "flag": "flags/Niger.png", "code": "NE"
        },
        {
            "country": "Nigeria", "dial_code": "+234", "flag": "flags/Nigeria.png", "code": "NG"
        },
        {
            "country": "Niue", "dial_code": "+683", "flag": "flags/Niue.png", "code": "NU"
        },
        {
            "country": "Norfolk Island", "dial_code": "+672", "flag": "flags/Norfolk_Island.png", "code": "NF"
        },
        {
            "country": "Northern Mariana Islands", "dial_code": "+1670", "flag": "flags/North_Korea.png", "code": "MP"
        },
        {
            "country": "Norway", "dial_code": "+47", "flag": "flags/Norway.png", "code": "NO"
        },
        {
            "country": "Oman", "dial_code": "+968", "flag": "flags/Oman.png", "code": "OM"
        },
        {
            "country": "Pakistan", "dial_code": "+92", "flag": "flags/Pakistan.png", "code": "PK"
        },
        {
            "country": "Palau", "dial_code": "+680", "flag": "flags/Palau.png", "code": "PW"
        },
        {
            "country": "Palestinian Territory, Occupied", "dial_code": "+970", "flag": "flags/Palestinian.png", "code": "PS"
        },
        {
            "country": "Panama", "dial_code": "+507", "flag": "flags/Panama.png", "code": "PA"
        },
        {
            "country": "Papua New Guinea", "dial_code": "+675", "flag": "flags/Papua_New_Guinea.png", "code": "PG"
        },
        {
            "country": "Paraguay", "dial_code": "+595", "flag": "flags/Paraguay.png", "code": "PY"
        },
        {
            "country": "Peru", "dial_code": "+51", "flag": "flags/Peru.png", "code": "PE"
        },
        {
            "country": "Philippines", "dial_code": "+63", "flag": "flags/Philippines.png", "code": "PH"
        },
        {
            "country": "Pitcairn", "dial_code": "+872", "flag": "flags/Pitcairn.png", "code": "PN"
        },
        {
            "country": "Poland", "dial_code": "+48", "flag": "flags/Poland.png", "code": "PL"
        },
        {
            "country": "Portugal", "dial_code": "+351", "flag": "flags/Portugal.png", "code": "PT"
        },
        {
            "country": "Puerto Rico", "dial_code": "+1939", "flag": "flags/Puerto_Rico.png", "code": "PR"
        },
        {
            "country": "Qatar", "dial_code": "+974", "flag": "flags/Qatar.png", "code": "QA"
        },
        {
            "country": "Romania", "dial_code": "+40", "flag": "flags/Romania.png", "code": "RO"
        },
        {
            "country": "Russia", "dial_code": "+7", "flag": "flags/Russian_Federation.png", "code": "RU"
        },
        {
            "country": "Rwanda", "dial_code": "+250", "flag": "flags/Rwanda.png", "code": "RW"
        },
        {
            "country": "Reunion", "dial_code": "+262", "flag": "flags/Reunion.png", "code": "RE"
        },
        {
            "country": "Saint Barthelemy", "dial_code": "+590", "flag": "flags/Serbia_and_Montenegro.png", "code": "BL"
        },
        {
            "country": "Saint Helena, Ascension and Tristan Da Cunha", "dial_code": "+290", "flag": "flags/Serbia_and_Montenegro.png", "code": "SH"
        },
        {
            "country": "Saint Kitts and Nevis", "dial_code": "+1869", "flag": "flags/Saint_Kitts_and_Nevis.png", "code": "KN"
        },
        {
            "country": "Saint Lucia", "dial_code": "+1758", "flag": "flags/Saint_Lucia.png", "code": "LC"
        },
        {
            "country": "Saint Martin", "dial_code": "+590", "flag": "flags/Saint.png", "code": "MF"
        },
        {
            "country": "Saint Pierre and Miquelon", "dial_code": "+508", "flag": "flags/Saint_Pierre.png", "code": "PM"
        },
        {
            "country": "Saint Vincent and the Grenadines", "dial_code": "+1784", "flag": "flags/Saint_Vicent_and_the_Grenadines.png", "code": "VC"
        },
        {
            "country": "Samoa", "dial_code": "+685", "flag": "flags/Samoa.png", "code": "WS"
        },
        {
            "country": "San Marino", "dial_code": "+378", "flag": "flags/San_Marino.png", "code": "SM"
        },
        {
            "country": "Sao Tome and Principe", "dial_code": "+239", "flag": "flags/Sao_Tomé_and_Príncipe.png", "code": "ST"
        },
        {
            "country": "Saudi Arabia", "dial_code": "+966", "flag": "flags/Saudi_Arabia.png", "code": "SA"
        },
        {
            "country": "Senegal", "dial_code": "+221", "flag": "flags/Senegal.png", "code": "SN"
        },
        {
            "country": "Serbia", "dial_code": "+381", "flag": "flags/Serbia_and_Montenegro.png", "code": "RS"
        },
        {
            "country": "Seychelles", "dial_code": "+248", "flag": "flags/Seychelles.png", "code": "SC"
        },
        {
            "country": "Sierra Leone", "dial_code": "+232", "flag": "flags/Sierra_Leone.png", "code": "SL"
        },
        {
            "country": "Singapore", "dial_code": "+65", "flag": "flags/Singapore.png", "code": "SG"
        },
        {
            "country": "Slovakia", "dial_code": "+421", "flag": "flags/Slovakia.png", "code": "SK"
        },
        {
            "country": "Slovenia", "dial_code": "+386", "flag": "flags/Slovenia.png", "code": "SI"
        },
        {
            "country": "Solomon Islands", "dial_code": "+677", "flag": "flags/Soloman_Islands.png", "code": "SB"
        },
        {
            "country": "Somalia", "dial_code": "+252", "flag": "flags/Somalia.png", "code": "SO"
        },
        {
            "country": "South Africa", "dial_code": "+27", "flag": "flags/South_Africa.png", "code": "ZA"
        },
        {
            "country": "South Sudan", "dial_code": "+211", "flag": "flags/South_Sudan.jpg", "code": "SS"
        },
        {
            "country": "South Georgia and the South Sandwich Islands", "dial_code": "+500", "flag": "flags/South_Georgia.png", "code": "GS"
        },
        {
            "country": "Spain", "dial_code": "+34", "flag": "flags/Spain.png", "code": "ES"
        },
        {
            "country": "Sri Lanka", "dial_code": "+94", "flag": "flags/Sri_Lanka.png", "code": "LK"
        },
        {
            "country": "Sudan", "dial_code": "+249", "flag": "flags/Sudan.png", "code": "SD"
        },
        {
            "country": "Suricountry", "dial_code": "+597", "flag": "flags/Suriname.png", "code": "SR"
        },
        {
            "country": "Svalbard and Jan Mayen", "dial_code": "+47", "flag": "flags/Svalbard.png", "code": "SJ"
        },
        {
            "country": "Swaziland", "dial_code": "+268", "flag": "flags/Swaziland.png", "code": "SZ"
        },
        {
            "country": "Sweden", "dial_code": "+46", "flag": "flags/Sweden.png", "code": "SE"
        },
        {
            "country": "Switzerland", "dial_code": "+41", "flag": "flags/Switzerland.png", "code": "CH"
        },
        {
            "country": "Syrian Arab Republic", "dial_code": "+963", "flag": "flags/Syria.png", "code": "SY"
        },
        {
            "country": "Taiwan", "dial_code": "+886", "flag": "flags/Taiwan.png", "code": "TW"
        },
        {
            "country": "Tajikistan", "dial_code": "+992", "flag": "flags/Tajikistan.png", "code": "TJ"
        },
        {
            "country": "Tanzania, United Republic of Tanzania", "dial_code": "+255", "flag": "flags/Tanzania.png", "code": "TZ"
        },
        {
            "country": "Thailand", "dial_code": "+66", "flag": "flags/Thailand.png", "code": "TH"
        },
        {
            "country": "Timor-Leste", "dial_code": "+670", "flag": "flags/Timor-Leste.png", "code": "TL"
        },
        {
            "country": "Togo", "dial_code": "+228", "flag": "flags/Togo.png", "code": "TG"
        },
        {
            "country": "Tokelau", "dial_code": "+690", "flag": "flags/Tokelau.png", "code": "TK"
        },
        {
            "country": "Tonga", "dial_code": "+676", "flag": "flags/Tonga.png", "code": "TO"
        },
        {
            "country": "Trinidad and Tobago", "dial_code": "+1868", "flag": "flags/Trinidad_and_Tobago.png", "code": "TT"
        },
        {
            "country": "Tunisia", "dial_code": "+216", "flag": "flags/Tunisia.png", "code": "TN"
        },
        {
            "country": "Turkey", "dial_code": "+90", "flag": "flags/Turkey.png", "code": "TR"
        },
        {
            "country": "Turkmenistan", "dial_code": "+993", "flag": "flags/Turkmenistan.png", "code": "TM"
        },
        {
            "country": "Turks and Caicos Islands", "dial_code": "+1649", "flag": "flags/Turks_and_Caicos_Islands.png", "code": "TC"
        },
        {
            "country": "Tuvalu", "dial_code": "+688", "flag": "flags/Tuvalu.png", "code": "TV"
        },
        {
            "country": "Uganda", "dial_code": "+256", "flag": "flags/Uganda.png", "code": "UG"
        },
        {
            "country": "Ukraine", "dial_code": "+380", "flag": "flags/Ukraine.png", "code": "UA"
        },
        {
            "country": "United Arab Emirates", "dial_code": "+971", "flag": "flags/United_States_of_America.png", "code": "AE"
        },
        {
            "country": "United Kingdom", "dial_code": "+44", "flag": "flags/United_Kingdom.png", "code": "GB"
        },
        {
            "country": "Uruguay", "dial_code": "+598", "flag": "flags/Uruguay.png", "code": "UY"
        },
        {
            "country": "Uzbekistan", "dial_code": "+998", "flag": "flags/Uzbekistan.png", "code": "UZ"
        },
        {
            "country": "Vanuatu", "dial_code": "+678", "flag": "flags/Vanuatu.png", "code": "VU"
        },
        {
            "country": "Venezuela, Bolivarian Republic of Venezuela", "dial_code": "+58", "flag": "flags/Venezuela.png", "code": "VE"
        },
        {
            "country": "Vietnam", "dial_code": "+84", "flag": "flags/Vietnam.png", "code": "VN"
        },
        {
            "country": "Virgin Islands, British", "dial_code": "+1284", "flag": "flags/Serbia_and_Montenegro.png", "code": "VG"
        },
        {
            "country": "Virgin Islands, U.S.", "dial_code": "+1340", "flag": "flags/Virgin_Islands.png", "code": "VI"
        },
        {
            "country": "Wallis and Futuna", "dial_code": "+681", "flag": "flags/Wallis_and_Futuna.png", "code": "WF"
        },
        {
            "country": "Yemen", "dial_code": "+967", "flag": "flags/Yemen.png", "code": "YE"
        },
        {
            "country": "Zambia", "dial_code": "+260", "flag": "flags/Zambia.png", "code": "ZM"
        },
        {
            "country": "Zimbabwe", "dial_code": "+263", "flag": "flags/Zimbabwe.png", "code": "ZW"
        }
    ]
}

